"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeToSource = exports.valueToSource = void 0;
const ast_1 = require("./ast");
const to_string_1 = require("./to-string");
const value_1 = require("./value");
const valueVisitor = {
    visitBoolean(value) {
        return (0, to_string_1.valueToString)(value);
    },
    visitDate(value) {
        return (0, to_string_1.valueToString)(value);
    },
    visitMonth(value) {
        return (0, to_string_1.valueToString)(value);
    },
    visitNumber(value) {
        return (0, to_string_1.valueToString)(value);
    },
    visitQuote(value) {
        return (0, to_string_1.valueToString)(value);
    },
    visitRecord(value) {
        let result = "{";
        let first = true;
        for (const [key, element] of value.elements) {
            if (first) {
                first = false;
            }
            else {
                result += ", ";
            }
            result += `${JSON.stringify(key)}: ${(0, exports.valueToSource)(element)}`;
        }
        result += "}";
        return result;
    },
    visitString(value) {
        return JSON.stringify(value.value);
    },
    visitTime(value) {
        return (0, to_string_1.valueToString)(value);
    },
    visitVector(value) {
        return `[${value.elements.map(exports.valueToSource).join(", ")}]`;
    },
    visitWeekday(value) {
        return (0, to_string_1.valueToString)(value);
    },
};
const nodeVisitor = {
    visitDefinition(node) {
        return `-> ${node.id}`;
    },
    visitLiteral(node) {
        return (0, exports.valueToSource)(node.value);
    },
    visitRecordLiteral(node) {
        let result = "{";
        let first = true;
        for (const [key, value] of node.elements) {
            if (first) {
                first = false;
            }
            else {
                result += ", ";
            }
            result += `${JSON.stringify(key)}: ${(0, exports.nodeToSource)(value)}`;
        }
        result += "}";
        return result;
    },
    visitSymbol(node) {
        return node.id;
    },
    visitVectorLiteral(node) {
        return `[${node.elements
            .map((element) => (0, exports.nodeToSource)(element))
            .join(", ")}]`;
    },
};
const valueToSource = (value) => (0, value_1.visitValue)(valueVisitor, value, undefined);
exports.valueToSource = valueToSource;
const nodeToSource = (node) => (0, ast_1.visitNode)(nodeVisitor, node, undefined);
exports.nodeToSource = nodeToSource;
